module.exports = __webpack_public_path__ + "img/floor.a4fe0297.png";